//@ts-nocheck

/**
 * Injects PWA meta tags from manifest response
 * @param {Object} manifest - The manifest object from getAppManifest API
 */
export const injectPWAMetaTags = (manifest) => {
  if (!manifest) return;

  // Update document title
  if (manifest.name) {
    document.title = manifest.name;
  }

  // Update theme-color meta tag
  if (manifest.theme_color) {
    updateOrCreateMetaTag('theme-color', manifest.theme_color);
  }

  // Update background color for PWA
  if (manifest.background_color) {
    updateOrCreateMetaTag(
      'msapplication-navbutton-color',
      manifest.background_color
    );
  }

  // Apple PWA meta tags
  updateOrCreateMetaTag('apple-mobile-web-app-capable', 'yes');
  updateOrCreateMetaTag('apple-mobile-web-app-status-bar-style', 'default');

  if (manifest.short_name || manifest.name) {
    updateOrCreateMetaTag(
      'apple-mobile-web-app-title',
      manifest.short_name || manifest.name
    );
  }

  // App description
  if (manifest.description) {
    updateOrCreateMetaTag('description', manifest.description);
  }

  // PWA display mode
  if (manifest.display) {
    updateOrCreateMetaTag('mobile-web-app-capable', 'yes');
  }

  // Add icons as apple-touch-icon and favicon
  if (manifest.icons && manifest.icons.length > 0) {
    addAppIcons(manifest.icons);
  }

  console.log('✅ PWA meta tags injected successfully');
};

/**
 * Updates or creates a meta tag
 * @param {string} name - The name of the meta tag
 * @param {string} content - The content of the meta tag
 */
const updateOrCreateMetaTag = (name, content) => {
  if (!content) return;

  // Try to find existing meta tag by name or property
  let metaTag =
    document.querySelector(`meta[name="${name}"]`) ||
    document.querySelector(`meta[property="${name}"]`);

  if (metaTag) {
    metaTag.setAttribute('content', content);
  } else {
    metaTag = document.createElement('meta');
    metaTag.setAttribute('name', name);
    metaTag.setAttribute('content', content);
    document.head.appendChild(metaTag);
  }
};

/**
 * Adds app icons (favicon and apple-touch-icon)
 * @param {Array} icons - Array of icon objects from manifest
 */
const addAppIcons = (icons) => {
  // Remove existing icons
  const existingIcons = document.querySelectorAll(
    'link[rel*="icon"], link[rel*="apple-touch-icon"]'
  );
  existingIcons.forEach((icon) => icon.remove());

  icons.forEach((icon) => {
    // Add apple-touch-icon for iOS
    const appleIcon = document.createElement('link');
    appleIcon.rel = 'apple-touch-icon';
    appleIcon.sizes = icon.sizes;
    appleIcon.href = icon.src;
    document.head.appendChild(appleIcon);

    // Add regular icon (favicon) for the largest size
    if (icon.sizes === '512x512' || icon.sizes.includes('512')) {
      const favicon = document.createElement('link');
      favicon.rel = 'icon';
      favicon.type = icon.type || 'image/png';
      favicon.href = icon.src;
      document.head.appendChild(favicon);
    }
  });

  // If no 512x512 icon, use the first available icon as favicon
  if (!icons.some((icon) => icon.sizes.includes('512'))) {
    const favicon = document.createElement('link');
    favicon.rel = 'icon';
    favicon.type = icons[0].type || 'image/png';
    favicon.href = icons[0].src;
    document.head.appendChild(favicon);
  }
};

/**
 * Cleans up dynamically created manifest URL
 */
export const cleanupPWAMetaTags = () => {
  if (window.currentManifestURL) {
    URL.revokeObjectURL(window.currentManifestURL);
    window.currentManifestURL = null;
  }
};

/**
 * Gets current PWA installation status
 */
export const getPWAStatus = () => {
  return {
    isStandalone:
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true,
    hasManifest: !!document.querySelector('link[rel="manifest"]'),
    hasServiceWorker: 'serviceWorker' in navigator,
    isOnline: navigator.onLine
  };
};
